<template>
    <set-azure-ea-credentials-dialog
        :value="value"
        @input="$emit('input', $event)"
        :loading="$wait.is('creatingAzureEaAccount')"
    >
        <template #activator="bindings">
            <slot name="activator" v-bind="bindings"></slot>
        </template>
        <template #actions="{ form, formId, isValid, clear, close }">
            <post-cloud-account-button
                :value="{ ...form, Type: 'AzureEa' }"
                :clear="clear"
                :valid="isValid"
                :form="formId"
                v-wait-while="'creatingAzureEaAccount'"
                @http2xx="close().then(() => $emit('http2xx', $event))"
            ></post-cloud-account-button>
        </template>
    </set-azure-ea-credentials-dialog>
</template>

<script>
import SetAzureEaCredentialsDialog from '@/components/Settings.CloudAccounts/Azure/SetAzureEaCredentialsDialog.vue';
import PostCloudAccountButton from '@/components/Settings.CloudAccounts/PostCloudAccountButton';
export default {
    components: { SetAzureEaCredentialsDialog, PostCloudAccountButton },
    props: {
        value: Boolean,
    },
};
</script>